
import { householdMemberTools } from '../tools/householdMemberTools';

export const getCurrentHouseholdMember = (adjustedFlow, activePage, householdMembers) => {
    if(adjustedFlow.length === 0) {
        return {
            hhmIndex: null,
            hhmGuid: null,
            currentHhm: {
                inlineEligibility: {},
                taxHouseholdComposition: {},
                flagBucket: {}
            }
        };
    }

    const currentHouseholdMemberIndex =  (idx => ~idx ? idx : null)(adjustedFlow[activePage] && adjustedFlow[activePage].hhm);

    return {
        hhmIndex: currentHouseholdMemberIndex,
        hhmGuid: currentHouseholdMemberIndex !== null ? householdMemberTools.extractFromHouseholdMembers(householdMembers).getGuidByIndexInArray(currentHouseholdMemberIndex) : null,
        currentHhm: householdMembers[currentHouseholdMemberIndex]
    };
};

